import CropFreeIcon from '@mui/icons-material/CropFree'
import { Box, Button, Container } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import React, { useContext, useState } from 'react'
import { Heading, QRCode } from '../../components'
import { AppContext } from '../../context/AppContextProvider'

const useStyles = makeStyles((theme) => ({
    box: {
        marginTop: theme.spacing(3),
        textAlign: 'center',
    },
    iframe: {
        height: 0,
        width: 0,
        border: 0,
    },
}))

export default function QRCodes(props) {
    const { paths, user } = useContext(AppContext)
    const [printUrl, setPrintUrl] = useState(null)
    const classes = useStyles()
    const leadFormTitle = 'New Patient Sign-Up'
    const leadFormUrl = `${window.location.origin}${paths.leadForm}?caregiver=${encodeURIComponent(user.email)}`

    function handlePrintClick(title, value) {
        const url = `${window.location.origin}/qrcode?${new URLSearchParams({ title, value, print: 'true' })}`

        // remove iframe to prevent issue printing twice in a row
        setPrintUrl(null)

        setTimeout(() => {
            setPrintUrl(url)
        })
    }

    return <Container maxWidth="sm">
        <Heading icon={<CropFreeIcon />}>
            QR Codes
        </Heading>

        <Box spacing={2} className={classes.box}>
            <QRCode title={leadFormTitle} value={leadFormUrl} />
            <Button
                color="primary"
                onClick={() => { handlePrintClick(leadFormTitle, leadFormUrl) }}
            >
                Print
            </Button>
        </Box>

        {printUrl &&
            <iframe className={classes.iframe} src={printUrl} frameBorder="0" scrolling="no"></iframe>
        }
    </Container>
}
